import React from "react";
import SingleCardLeftIcon from "@qlik/qlik/src/components/Card/Single-Card-Left-Icon";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";

/**
 * IconCardsTwoColumns component
 * @param {Object} props - The props for the component
 * @param {Object} props.data - The data for the component
 * @returns {JSX.Element} - Rendered component
 */
const IconCardsTwoColumns = ({ data }) => {
    // Destructure data
    const { customId, title, subtitle, description, cardItems = [], additionalConfiguration } = data ?? {};

    // Determine if the first row should be rendered
    const shouldRenderFirstRow = title || subtitle || description?.description;

    // Get the class name for section padding
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "");

    return (
        <section
            data-section="true"
            id={customId}
            className={`py-12.5 lg:pt-30 lg:pb-30 bg-stone-light scroll-mt-45 ${sectionSpacingClassName}`}
        >
            <div className="container">
                {shouldRenderFirstRow && (
                    <div className="row">
                        <div className="col-12 mb-5 md:mb-14.5">
                            {title && (
                                <h2
                                    className="text-center mb-5"
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                                />
                            )}
                            {subtitle && <p className={`body-big text-center mb-5  `}>{subtitle}</p>}
                            {description?.description && (
                                <p className={`body-big text-center mb-5 `}>{description?.description}</p>
                            )}
                        </div>
                    </div>
                )}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-25 gap-y-7.5">
                    {cardItems?.map((cardItem) => (
                        <div key={cardItem.id}>
                            <SingleCardLeftIcon data={cardItem} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default IconCardsTwoColumns;
